import * as Sentry from "@sentry/nextjs";

const logger = Sentry.logger;
export default logger;
